import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ThumbsUpIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.99 9.61997C15.91 9.03997 15.26 8.65997 14.56 8.56997C14.41 8.54997 14.24 8.52997 14.07 8.51997C14.13 8.50997 14.18 8.50997 14.23 8.49997C14.94 8.41997 15.46 8.02997 15.38 7.44997C15.3 6.86997 14.65 6.48997 13.95 6.39997C13.61 6.35997 13.23 6.32997 12.82 6.30997V6.30997C12.82 6.30997 12.82 6.30997 12.81 6.30997C12.57 6.29997 12.32 6.28997 12.06 6.28997C11.58 6.26997 10.95 6.24997 10.47 6.20997C10.11 6.17997 10.06 5.92997 10.1 5.67997C10.45 4.77997 10.64 3.76997 10.6 2.76997C10.56 1.91997 10 1.08997 9.19 0.999974C8.52 0.929974 8.03 1.38997 8.2 1.97997C8.76 3.90997 6.13 6.19997 4 7.48997V13.49C5.66 14.52 8.35 15.05 11.48 14.99C11.67 14.99 11.87 14.98 12.1 14.97C12.13 14.97 12.16 14.97 12.19 14.97V14.97C12.41 14.96 12.65 14.94 12.92 14.92C13.63 14.86 14.46 14.41 14.42 13.83C14.39 13.32 14.02 13.04 13.55 12.9C13.82 12.88 14.09 12.86 14.34 12.84C15.05 12.78 15.58 12.39 15.51 11.8C15.45 11.22 14.81 10.83 14.1 10.73C14.08 10.73 14.05 10.72 14.03 10.72C14.32 10.7 14.6 10.69 14.84 10.67C15.55 10.64 16.07 10.2 15.99 9.61997ZM2 6.99997H0V14H2C2.55 14 3 13.55 3 13V7.99997C3 7.43997 2.55 6.99997 2 6.99997Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ThumbsUpIcon;
